import { Icon, Table, Text } from '@quintoandar-tokko/jopijs';
import styles from '../dashboardTables.module.scss';
import PropertyOrDevelopmentCell from '../components/PropertyOrDevelopmentCell';
import ContactCell from '../components/ContactCell';
import AgentBranchCell from '../components/AgentBranchCell';

export default function ConcretedOperationsTableRow({ row }) {
  const {
    id,
    origin,
    agent,
    operation,
    property,
    property_type,
    entry_date,
    close_date,
    value,
    contact,
    branch,
  } = row;

  return (
    <Table.RowDefault id={id} variant="secondary">
      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <PropertyOrDevelopmentCell
          id={property?.id}
          thumbnail={property?.thumbnail}
          address={property?.address}
          location={property?.location}
          modal="concretedOperations"
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <Text variant="body.fontSize13">{operation}</Text>
        <Text variant="body.fontSize13">{property_type}</Text>
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        {value ? (
          <Text variant="body.fontSize13">{`${value?.currency} ${value?.value}`}</Text>
        ) : (
          <Icon icon="icon-mostrarmenos" className={styles.emptyDataIcon} />
        )}
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <ContactCell
          highlighted={false}
          id={contact?.id}
          cellphone={contact?.cellphone}
          name={contact?.name}
          email={contact?.email}
          image={contact?.image}
          agent={agent}
          leadStatus={contact?.lead_status}
          relativeSelector="#concreted-operations-modal"
          modal="concretedOperations"
        />
        {origin ? (
          <Text variant="body.fontSize13">{origin}</Text>
        ) : (
          <Icon icon="icon-mostrarmenos" className={styles.emptyDataIcon} />
        )}
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <AgentBranchCell
          agentId={agent?.id}
          agentName={agent?.name}
          branchName={agent?.branch_name || branch?.name}
          image={agent.profile_picture}
          relativeSelector="#concreted-operations-modal"
          withBranch
          withBoldTitle
          modal="concretedOperations"
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <Text variant="body.fontSize13">{entry_date}</Text>
        <Text variant="body.fontSize13">{close_date}</Text>
      </Table.RowItemDefault>
    </Table.RowDefault>
  );
}
